import React from 'react';
import { Link } from 'react-scroll'; // Import Link from react-scroll
import { navData } from '../data';

const Nav = () => {
  // Destructure nav data
  const { items } = navData;

  return (
    <nav>
      <ul className="flex gap-x-[58px]">
        {items.map((item, index) => {
          if (item.name === 'Contact') {
            // Use react-scroll Link for the "Contact" item
            return (
              <li key={index}>
                <Link
                  className="link hover:border-b-2 hover:border-dark transition duration-300"
                  to="contact"
                  smooth={true}
                  duration={500}
                >
                  {item.name}
                </Link>
              </li>
            );
          }

          // For other links, use regular anchor tags or other logic as needed
          return (
            <li key={index}>
              <a
                className="link hover:border-b-2 hover:border-dark transition duration-300"
                href={item.href}
              >
                {item.name}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
